import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "details-form__item" }
const _hoisted_2 = { class: "details-form__item" }
const _hoisted_3 = { class: "details-form__item" }

import {computed, inject, onBeforeUnmount, onMounted, ref} from 'vue';
    import {useStore} from 'vuex';
    import {useRouter} from 'vue-router';
    import {useGlobalProperties} from '@malt/vue3-use';
    import LocalisationSide from '@/profile-creation-wizard/components/for-creation/ui/4_localisation/LocalisationSide.vue';
    import PhoneSelection from '@/profile-creation-wizard/components/for-creation/ui/4_localisation/PhoneSelection.vue';
    import {DI} from '@/profile-creation-wizard/common/DependencyInjection';
    import mutations from '@/profile-creation-wizard/store/creation/mutations';
    import {pushVJoySnackbar} from '@maltjoy/core-vue';
    import getters from '@/profile-creation-wizard/store/creation/getters';
    import LanguageSelection from '@/profile-creation-wizard/components/for-creation/ui/4_localisation/LanguageSelection.vue';
    import {ProfileCreationFunnelMode} from '@/profile-creation-wizard/config/steps/ProfileCreationSteps';
    import LocationAndWorkplace from '@/profile-creation-wizard/components/for-creation/ui/4_localisation/location/LocationAndWorkplace.vue';
    import Step from '@/profile-creation-wizard/common/ui/step/Step.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'LocalisationStep',
  setup(__props) {

    const store = useStore();
    const router = useRouter();
    const {$pageContext, $features} = useGlobalProperties();

    const creationFormValidation = inject(DI.creationFormValidation);
    const profileCreationService = inject(DI.profileCreationService);
    const trackingRepository = inject(DI.trackingRepository);
    const creationForm = ref(store.getters[getters.creationForm]);

    const locationAndWorkplace = ref<LocationAndWorkplace>();

    const funnelMode = computed(() => store.state.funnelMode);

    const loading = ref(false);
    const isBlockedCountry = ref(false);
    const isPhoneOptional = computed(() => funnelMode.value === ProfileCreationFunnelMode.FREELANCER);
    const isCompletelyValid = computed(() => {
        if (loading.value || isBlockedCountry.value) {
            return false;
        }
        return creationFormValidation!.isValid(creationForm.value, store.getters[getters.priceConfiguration], funnelMode.value);
    });

    onMounted(() => {
        window.Hop.events.on('user:connected', submit);
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    });

    onBeforeUnmount(() => {
        window.Hop.events.off('user:connected', submit);
    });

    function checkCountryValidity(): void {
        isBlockedCountry.value = locationAndWorkplace.value.isBlockedCountry;
    }

    async function submit(): Promise<void> {
        loading.value = true;
        if (localStorage.getItem('mfi-code')) {
            store.commit(mutations.selectInvitationCode, localStorage.getItem('mfi-code'));
            localStorage.removeItem('mfi-code');
        }

        let groupInvitation = $pageContext.groupInvitation;
        if (!groupInvitation) {
            groupInvitation = localStorage.getItem('grp-code');
        }

        if (groupInvitation) {
            store.commit(mutations.selectGroupInvitationId, groupInvitation);
            localStorage.removeItem('grp-code');
        }

        if (!$pageContext.isConnected) {
            const [response, error] = await profileCreationService!.saveProfileCreationRequest(creationForm.value, funnelMode.value);
            loading.value = false;

            if (error) {
                if (error.response?.status === 401) {
                    pushVJoySnackbar({
                        props: {
                            message: error.response.data,
                            level: 'error',
                        },
                    });
                }
                if (error.response?.status === 400) {
                    error.response.data.forEach((errorItem: any) => {
                        pushVJoySnackbar({
                            props: {
                                message: errorItem.error,
                                level: 'error',
                            },
                        });
                    });
                }
                return;
            }

            if (response) {
                store.commit(mutations.updateProfileCreationResumptionDetails, response);
                router.push({name: router.currentRoute.value.meta.nextStep});
            }
        } else {
            const [response, error] = await profileCreationService!.createProfile(creationForm.value, funnelMode.value);

            if (error) {
                if (error.response?.status === 401) {
                    pushVJoySnackbar({
                        props: {
                            message: error.response.data,
                            level: 'error',
                        },
                    });
                }
                if (error.response?.status === 400) {
                    error.response.data.forEach((errorItem: any) => {
                        pushVJoySnackbar({
                            props: {
                                message: errorItem.error,
                                level: 'error',
                            },
                        });
                    });
                }
                loading.value = false;
                return;
            }

            if (response) {
                location.href = router.resolve({name: router.currentRoute.value.meta.nextStep}).href;
            }
        }
    }

    function goNext(): void {
        if (!isCompletelyValid.value) {
            return;
        }

        if (funnelMode.value === ProfileCreationFunnelMode.STRATEGY) {
            trackingRepository!.track('localisation-willingness-to-travel-strategy', {
                willingnessToTravel: creationForm.value.willingnessToTravelInternationally,
            });
        }

        trackingRepository!.track(`languages-chosen-${store.state.funnelMode}`, {
            languages: creationForm.value.languages.map((language) => ({
                language: language.query,
                code: language.code,
                level: language.level,
            })),
        });

        trackingRepository!.track(`location-chosen-${store.state.funnelMode}`, {
            location: creationForm.value.address,
        });

        askForSignupAccount();
    }

    async function askForSignupAccount() {
        await submit();
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Step, {
    "is-step-valid": isCompletelyValid.value,
    onGoToNext: goNext
  }, {
    "step-content": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(LocationAndWorkplace, {
          ref_key: "locationAndWorkplace",
          ref: locationAndWorkplace,
          "funnel-mode": funnelMode.value,
          onChange: checkCountryValidity
        }, null, 8, ["funnel-mode"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(LanguageSelection)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(PhoneSelection, { optional: isPhoneOptional.value }, null, 8, ["optional"])
      ])
    ]),
    "step-side": _withCtx(() => [
      _createVNode(LocalisationSide)
    ]),
    _: 1
  }, 8, ["is-step-valid"]))
}
}

})